<template>
  <div v-if="reimbursementInfo" ref="reimbursement_content" class="reimbursement-box">
    <div class="reimbursement-headers" :class="'headers-background-'+reimbursementInfo.applyStatus">
      <headers
        :headInfo="{headUrl: reimbursementInfo.dingDingPhotoPath, dingdingUserId:reimbursementInfo.currentApplyDingDingId, userName: reimbursementInfo.currentApplyEmployeeName, approver: reimbursementInfo.nextApprover, approvalState: reimbursementInfo.applyStatus }"
      ></headers>
    </div>
    <div ref="reimbursement_tab" class="reimbursement-tab">
      <tab :tabconfig="tabconfig"></tab>
    </div>
    <div class="mian-box">
      <div class="reimbursement-info d_jump">
        <div class="reimbursement-info-content">
          <div class="reimbursement-info-box">
            <div class="reimbursement-info-label">项目名称</div>
            <router-link
              v-if="reimbursementInfo.projectType=='Business'"
              class="reimbursement-info-content bg-color"
              :to="{name:'projectInfo',query:{projectCode:reimbursementInfo.projectCode}}"
            >{{reimbursementInfo.projectName}}</router-link>
            <div v-else class="reimbursement-info-content">{{reimbursementInfo.projectName}}</div>
          </div>
          <div class="reimbursement-info-box">
            <div class="reimbursement-info-label">支出项目</div>
            <div class="reimbursement-info-content">{{reimbursementInfo.payItemName}}</div>
          </div>
          <div class="reimbursement-info-box">
            <div class="reimbursement-info-label">业务单元</div>
            <div class="reimbursement-info-content">{{reimbursementInfo.financialDeptName}}</div>
          </div>
          <div class="reimbursement-info-box">
            <div class="reimbursement-info-label">经办人</div>
            <div class="reimbursement-info-content">{{reimbursementInfo.operatorEmployeeName}}</div>
          </div>
          <div class="reimbursement-info-box">
            <div class="reimbursement-info-label">请款金额</div>
            <div class="reimbursement-info-content">{{reimbursementInfo.paymentAmount|NumFormat}}元</div>
          </div>
          <div class="reimbursement-info-box">
            <div class="reimbursement-info-label">请款公司</div>
            <div class="reimbursement-info-content">{{reimbursementInfo.paymentCompanyName}}</div>
          </div>
          <div class="reimbursement-info-box">
            <div class="reimbursement-info-label">支付形式</div>
            <div class="reimbursement-info-content">{{reimbursementInfo.paymentType}}</div>
          </div>
          <div class="reimbursement-info-box">
            <div class="reimbursement-info-label">资金使用说明</div>
            <div
              class="reimbursement-info-content"
              v-html="$options.filters.textareaToFormat(reimbursementInfo.useFundsExplain)"
            ></div>
          </div>
          <div class="reimbursement-info-box">
            <div class="reimbursement-info-label">实际用途</div>
            <div
              class="reimbursement-info-content"
              v-html="$options.filters.textareaToFormat(reimbursementInfo.actualReimSummary)"
            ></div>
          </div>
          <div class="reimbursement-info-box">
            <div class="reimbursement-info-label">项目结案报告</div>
            <div class="reimbursement-info-content">
              <filebox message="暂无相关文档" :fileInfo="fileInfo"></filebox>
            </div>
          </div>
        </div>
        <div class="divide-line"></div>
        <!--采购信息开始-->
        <div class="purchaseInfo-content">
          <div v-if="reimbursementInfo.purchaseInfo" class="purchase-order">
            <div class="purchase-order-label">采购申请信息</div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">采购项目</div>
              <div class="purchase-info-content">{{reimbursementInfo.purchaseInfo.purchaseKindName}}</div>
            </div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">采购总金额</div>
              <div
                class="purchase-info-content"
              >{{reimbursementInfo.purchaseInfo.totalPrice|NumFormat}}元（已付金额：{{reimbursementInfo.approvePaymentAmounts|NumFormat}}元；未付金额：{{(reimbursementInfo.purchaseInfo.totalPrice-reimbursementInfo.purchaseInfo.approvePaymentAmounts)|NumFormat}}元）</div>
            </div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">采购分类</div>
              <div class="purchase-info-content">{{reimbursementInfo.purchaseInfo.purchaseKindName}}</div>
            </div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">采购需求人</div>
              <div
                class="purchase-info-content"
              >{{reimbursementInfo.purchaseInfo.requirementName+"-"+reimbursementInfo.purchaseInfo.requirementDeptName}}</div>
            </div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">相关文档</div>
              <div class="purchase-info-content">
                <filebox message="暂无采购相关文档" :fileInfo="purchaseFileInfo"></filebox>
              </div>
            </div>
            <div
              v-for="(item,index) in reimbursementInfo.purchaseInfo.detailsList"
              :key="index"
              class="purchase-orderinfo"
            >
              <div class="orderinfo-title-box">
                <div class="orderinfo-title">供货商</div>
                <div class="orderinfo-supplier">{{item.mainSupplierName}}</div>
              </div>
              <div class="orderinfo-title-box">
                <div class="orderinfo-title">物品</div>
                <div class="orderinfo-supplier">{{item.goodsName}}</div>
              </div>
              <div class="orderinfo-foot">
                <div class="first-child">单价</div>
                <div class="orderinfo-amount">{{item.mainSupplierPrice|NumFormat}}元</div>
                <div class="third-child">合计金额</div>
                <div class="orderinfo-amount">{{item.mainSupplierTotalPrice|NumFormat}}元</div>
              </div>
            </div>
            <div class="purchase-process">
              <lite-process :approvalList="reimbursementInfo.purchaseInfo.approvalList"></lite-process>
            </div>
          </div>
        </div>
        <!--采购信息结束-->

        <div class="divide-line"></div>

        <!--收款账户信息开始-->
        <div class="purchaseInfo-content">
          <div class="purchase-order">
            <div class="purchase-order-label">收款账户信息</div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">收款单位</div>
              <div class="purchase-info-content">{{reimbursementInfo.payeeCompany}}</div>
            </div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">收款账号</div>
              <div class="purchase-info-content">{{reimbursementInfo.payeeAccount}}</div>
            </div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">开户行</div>
              <div class="purchase-info-content">{{reimbursementInfo.payeeDepositBank}}</div>
            </div>
          </div>
        </div>
        <!--收款账户信息结束-->
        <div class="divide-line"></div>
        <!--发票信息开始-->
        <div v-if="paramInfo.applyTypeId=='T043'">
          <div class="purchaseInfo-content">
            <div class="purchase-order">
              <div class="purchase-order-label">发票信息</div>
              <div class="purchase-info-box">
                <div class="purchase-info-label">发票金额</div>
                <div class="purchase-info-content">{{reimbursementInfo.invoiceAmount|NumFormat}}元</div>
              </div>
              <div class="purchase-info-box">
                <div class="purchase-info-label">是否增值税发票</div>
                <div
                  class="purchase-info-content"
                >{{reimbursementInfo.vATInvoiceFlag=='YES'?'是':'否'}}</div>
              </div>
              <div class="purchase-info-box">
                <div class="purchase-info-label">发票张数</div>
                <div class="purchase-info-content">{{reimbursementInfo.invoiceCount}}</div>
              </div>
              <div class="purchase-info-box">
                <div class="purchase-info-label">发票文件</div>
                <div class="purchase-info-content">
                  <filebox message="暂无发票相关文档" :fileInfo="invoiceFileInfo"></filebox>
                </div>
              </div>
            </div>
          </div>
          <!--发票信息结束-->
          <div class="divide-line"></div>
        </div>
      </div>
      <div class="process d_jump">
        <process
          :approvalList="reimbursementInfo.approvalList"
          :applyEmployeeID="reimbursementInfo.applyEmployeeID"
        ></process>
      </div>
    </div>
    <div class="reimbursement-foot">
      <exefoot
        :paramInfo="{...paramInfo,approveStep:reimbursementInfo.nextApproveStep}"
        v-if="reimbursementInfo.nextApproverId&&reimbursementInfo.nextApproverId.indexOf(userInfo.employeeID)>-1&&reimbursementInfo.applyStatus=='SUBMIT'"
      ></exefoot>
      <selffoot
        :paramInfo="paramInfo"
        :urgeInfo="{approverUserId:reimbursementInfo.nextApproverUserId,applyEmployeeName:reimbursementInfo.currentApplyEmployeeName,path:urgePath,applyTypeName:applyTypeName}"
        v-else-if="reimbursementInfo.applyEmployeeID==userInfo.employeeID&&reimbursementInfo.applyStatus=='SUBMIT'"
      ></selffoot>
      <passfoot :paramInfo="paramInfo" v-else></passfoot>
    </div>
  </div>
</template>
<script>
import liteProcess from "@/components/Approval/ApprovalProcess/approvalProcess_Lite";
import headers from "@/components/Approval/ApprovalHead/index";
import tab from "@/components/Share/Tab";
import process from "@/components/Approval/ApprovalProcess/index";
import exefoot from "@/components/Approval/ApprovalFoot/approvalExeFoot";
import selffoot from "@/components/Approval/ApprovalFoot/approvalSelfFoot";
import passfoot from "@/components/Approval/ApprovalFoot/approvalPassFoot";
import filebox from "@/components/Share/Preview/fileBox";
import { mapState, mapMutations } from "vuex";
import http from "@/utils/http";
export default {
  data() {
    return {
      paramInfo: {},
      reimbursementInfo: {},
      fileInfo: {},
      purchaseFileInfo: {}, //采购相关文档
      invoiceFileInfo: {}, //发票相关文件
      urgePath: "/FD/prepayment", //催办时由于当前页面是预付费和报销共用
      applyTypeName: "预付账款申请",
      tabconfig: {
        defaultValue: 0,
        backFun: this.tabClickBackFun,
        affixNum: 0,
        tabList: [
          { key: 0, value: "申请信息" },
          { key: 1, value: "审批信息" }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  methods: {
    ...mapMutations(["setTitleInfo"]),
    tabClickBackFun(index) {},
    getPurchaseInfo(applyId, applyTypeId) {
      let _this = this;
      this.$Spin.show();
      return new Promise((resolve, reject) => {
        http
          .get(
            `/api/FD/reimbursement/GetReimbursementApplyInfo?applyId=${applyId}&applyTypeId=${applyTypeId}`
          )
          .then(res => {
            _this.$Spin.hide();
            if (res.data && res.data.data) {
              _this.setTitleInfo({
                title: "",
                bg: res.data.data.applyStatus,
                isMore: true
              });
              _this.fileInfo = {
                filesrcs: res.data.data.reportFilePath,
                filenames: res.data.data.reportFileName
              };
              if (res.data.data.purchaseInfo != null) {
                _this.purchaseFileInfo = {
                  filesrcs: res.data.data.purchaseInfo.quotationPath,
                  filenames: res.data.data.purchaseInfo.quotationFName
                };
              }
              if (res.data.data.invoiceFile.length > 0) {
                let invoiceFilePath = "";
                let invoiceFileName = "";
                res.data.data.invoiceFile.forEach((item, index, arr) => {
                  invoiceFilePath += item.invoiceFilePath + "|";
                  invoiceFileName += item.invoiceFileName + "|";
                });

                _this.invoiceFileInfo = {
                  filesrcs: invoiceFilePath,
                  filenames: invoiceFileName
                };
              }
              resolve(res.data.data || {});
            } else resolve({});
          });
      });
    }
  },
  async mounted() {
    let _this = this;
    this.paramInfo = { ...this.$route.query };
    if (this.paramInfo.applyTypeId == "T043") {
      this.urgePath = "/FD/prepayment";
      this.applyTypeName = "报销申请";
    }
    this.reimbursementInfo = await this.getPurchaseInfo(
      this.paramInfo.applyId,
      this.paramInfo.applyTypeId
    );
    this.$nextTick(() => {
      _this.tabconfig.affixNum =
        _this.$refs.reimbursement_content.offsetTop - 1;
      _this.$refs.reimbursement_tab.style =
        "top:" + _this.tabconfig.affixNum + "px";
    });
  },
  components: {
    liteProcess,
    headers,
    tab,
    process,
    exefoot,
    selffoot,
    passfoot,
    filebox
  }
};
</script>

<style lang="less" scoped>
.reimbursement-box {
  .reimbursement-headers {
    padding: 0 0.4rem;
  }

  .reimbursement-tab {
    width: 100%;
    height: 1.44rem;
    position: sticky;
    z-index: 9;
    background: #fff;
    display: flex;
    align-items: center;
  }
  .mian-box {
    padding-bottom: 1.6rem;
    .reimbursement-info {
      .reimbursement-info-content {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .reimbursement-info-box {
          margin-top: 0.533333rem;
          font-size: 0.373333rem;
          display: flex;
          .reimbursement-info-label {
            text-align: center;
            flex: 1;
            color: #999;
          }
          .reimbursement-info-content {
            margin-left: 0.133333rem;
            width: 80%;
            color: #333333;
          }
          .bg-color{
            color: #55b9fc!important;
          }
        }
      }
      .divide-line {
        width: 100%;
        height: 0.133333rem;
        background: #f5f5f5;
      }
      .purchaseInfo-content {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .purchase-order {
          .purchase-order-label {
            height: 1.253333rem;
            line-height: 1.253333rem;
            font-size: 0.453333rem;
            color: #333333;
            font-weight: bold;
            border-bottom: 1px solid #eee;
          }
          .purchase-info-box {
            margin-top: 0.533333rem;
            font-size: 0.373333rem;
            display: flex;
            .purchase-info-label {
              text-align: center;
              flex: 1;
              color: #999;
            }
            .purchase-info-content {
              margin-left: 0.133333rem;
              width: 76%;
              color: #333333;
            }
          }
          .purchase-process {
            margin-top: 0.4rem;
          }
        }
      }
      .purchase-paymentHistory {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .purchase-order-label {
          height: 1.253333rem;
          line-height: 1.253333rem;
          font-size: 0.453333rem;
          color: #333333;
          font-weight: bold;
          border-bottom: 1px solid #eee;
        }
      }
      .purchase-orderinfo {
        margin-top: 0.533333rem;
        width: 100%;
        font-size: 0.373333rem;
        border: 1px solid #eee;
        .orderinfo-title-box {
          width: 100%;
          border-bottom: 1px solid #eee;
          display: flex;
          text-align: center;
          .orderinfo-title {
            width: 1.333333rem;
            min-height: 1.08rem;
            color: #999;
            border-right: 1px solid #eee;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .orderinfo-supplier {
            flex: 1;
            color: #333333;
            padding: 0.13rem;
          }
        }
        .borderbottom {
          border-bottom: 1px solid #eee;
          .borderleft {
            min-width: 1.066667rem;
            border-left: 1px solid #eee;
          }
        }
        .orderinfo-foot {
          width: 100%;
          display: flex;
          color: #999;
          .first-child {
            width: 1.333333rem;
          }
          .third-child {
            width: 2rem;
            border-left: 1px solid #eee;
          }
          div {
            height: 1.08rem;
            line-height: 1.08rem;
            text-align: center;
          }
          .orderinfo-amount {
            flex: 1;
            color: #333;
            border-left: 1px solid #eee;
          }
        }
        .handle {
          height: 0.8rem;
          line-height: 0.8rem;
          text-align: right;
          padding-right: 0.4rem;
        }
      }
    }
    .process {
      margin-top: 0.4rem;
      padding: 0 0.4rem;
    }
  }
  .reimbursement-foot {
    padding: 0 0.4rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.6rem;
    background: #fff;
    z-index: 9;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/FD/Reimbursement/index.vue